import React from 'react'
import "./styles/CountReleasedAttachments.scss"

const CountReleasedAttachments = (props) => {

  const { countProjects } = props

  return (
    <div id="CountReleasedAttachments">
      &nbsp; { countProjects } projetos
    </div>
  )
}

export default CountReleasedAttachments